import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboardmain.css";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import axios from "../../axios/axios";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Badge, Card, CardBody, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { H4 } from "../../AbstractElements";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdOutlineCancel } from "react-icons/md";
import { GoIssueClosed } from "react-icons/go";
import { IoAlertCircleOutline, IoLockClosedOutline } from "react-icons/io5";
import CountUp from "react-countup";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

const Dashboardmain = () => {
  const navigate = useNavigate();
  const baseurl = useSelector((store) => store.baseUrl);
  const AUTHORIZE_KEY = "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy";
  const userdetails = JSON.parse(localStorage.getItem("userdetails")) || {};
  const withoutstockbypass = userdetails?.withoutstockbypass == "1"; // ✅ NEW
  const componentRef = useRef();
  const image_url_logo = localStorage.getItem("company_logo_pos");
  const [searchtext, setSearchtext] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [filteredinvoiceData, setFilteredInvoiceData] = useState([]);
  const [data_info, setDatainfo] = useState("");
  const [invoiceinfo, setInvoiceinfo] = useState({});
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [topProducts, setTopProducts] = useState([]);
  const [filteredTopProducts, setFilteredTopProducts] = useState([]);
  const [productsInfo, setProductsInfo] = useState("");
  const [selectedView, setSelectedView] = useState("invoice");
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);

  // Product Movement States
  const [productMovementData, setProductMovementData] = useState([]);
  const [filteredProductMovementData, setFilteredProductMovementData] = useState([]);
  const [loadingProductMovement, setLoadingProductMovement] = useState(false);
  const [productMovementInfo, setProductMovementInfo] = useState("");

  // Date Filter States
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branch_arr, setBrancharr] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(""); // "" = not selected initially

  // Invoice tab state
  const [invoiceTab, setInvoiceTab] = useState("processed"); // "pending" | "processed"

  // Selection state
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Pagination params sent to API
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);

  // Confirmation modal / processing
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmTarget, setConfirmTarget] = useState(null); // { type: 'single' | 'bulk', ids: [], invoiceNos: [] }
  const [isProcessingInvoices, setIsProcessingInvoices] = useState(false);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorPayload, setErrorPayload] = useState(null);

  const closeErrorModal = () => {
    setShowErrorModal(false);
    setErrorPayload(null);
  };

  const handleComposeButtonClick = () => {
    navigate(`${process.env.PUBLIC_URL}/dashboardpos`);
  };

  const fetchBranches = () => {
    axios
      .post("/supportportalapi/branches/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        PHPTOKEN: localStorage.getItem("id_token"),
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          setBrancharr(response.data[0].DATA.branch_arr);
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  };

  // Format date to required format: "dd-mm-yyyy" (without time)
  const formatDateForAPI = (dateString) => {
    const date = moment(dateString);
    return date.format("DD-MM-YYYY");
  };

  // Get today's date in YYYY-MM-DD format for input
  const getTodayDate = () => {
    return moment().format("YYYY-MM-DD");
  };

  // Set initial dates to today
  const setInitialDates = () => {
    const today = getTodayDate();
    setFromDate(today);
    setToDate(today);
    return {
      start_dt: formatDateForAPI(today),
      end_dt: formatDateForAPI(today)
    };
  };

  // Get current date parameters
  const getDateParams = () => {
    if (fromDate && toDate) {
      return {
        start_dt: formatDateForAPI(fromDate),
        end_dt: formatDateForAPI(toDate)
      };
    }
    return setInitialDates();
  };

  // Get today's date parameters for reset
  const getTodayDateParams = () => {
    const today = getTodayDate();
    return {
      start_dt: formatDateForAPI(today),
      end_dt: formatDateForAPI(today)
    };
  };

  // Number formatting utilities
  const formatNumber = (number, country = 'IN') => {
    if (!number && number !== 0) return '0';

    const num = parseFloat(number);
    if (isNaN(num)) return '0';

    const formatters = {
      'IN': (n) => n.toLocaleString('en-IN'),
      'US': (n) => n.toLocaleString('en-US'),
      'EU': (n) => n.toLocaleString('de-DE'),
      'CN': (n) => n.toLocaleString('zh-CN'),
    };

    const formatter = formatters[country] || formatters['IN'];
    return formatter(num);
  };

  // Calculate total amount for invoicewise sales
  const calculateTotalAmount = (data) => {
    if (!data || data.length === 0) return 0;

    return data.reduce((total, invoice) => {
      const amount = parseFloat(invoice.Amount) || 0;
      return total + amount;
    }, 0);
  };

  // Format currency with symbol and proper formatting
  const formatCurrency = (amount, country = 'IN', currency = 'INR') => {
    const formattedNumber = formatNumber(amount, country);

    const currencySymbols = {
      'INR': '₹',
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'CNY': '¥'
    };

    const symbol = currencySymbols[currency] || currency;

    return `${symbol} ${formattedNumber}`;
  };

  // Trim float noise like "57.46999999999999" → "57.47", and "58" stays "58"
  // const formatQty = (qty) => {
  //   const num = parseFloat(qty);
  //   if (isNaN(num)) return "0";
  //   // round to 2 decimals, then drop trailing zeros (57.50 → 57.5, 58.00 → 58)
  //   return parseFloat(num.toFixed(2)).toString();
  // };

  const formatQty = (qty) => {
    const num = parseFloat(qty);
    if (isNaN(num)) return "0";
    return parseFloat(num.toFixed(3)).toString();  // 3-decimal cap for fine-grained units
  };

  // Switch between Pending / Processed
  const handleInvoiceTabChange = (tab) => {
    if (tab === invoiceTab) return;
    setInvoiceTab(tab);
    setCurrentPage(1);
    setSelectedInvoiceIds([]);
    setSelectAllChecked(false);
    const dateParams = getDateParams();
    fetchTransactionList(dateParams, null, tab, 1, pageLimit);
  };

  // Row checkbox
  const handleSelectRow = (id) => {
    setSelectedInvoiceIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // Header "select all" checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const pageIds = getCurrentPageRows(filteredinvoiceData).map((row) => row.ID);
    setSelectAllChecked(checked);
    setSelectedInvoiceIds(checked ? pageIds : []);
  }

  // Keep header checkbox synced with row selections
  // useEffect(() => {
  //   if (filteredinvoiceData.length > 0 && selectedInvoiceIds.length === filteredinvoiceData.length) {
  //     setSelectAllChecked(true);
  //   } else {
  //     setSelectAllChecked(false);
  //   }
  // }, [selectedInvoiceIds, filteredinvoiceData]);

  useEffect(() => {
    const pageIds = getCurrentPageRows(filteredinvoiceData).map((r) => r.ID);
    const allSelected =
      pageIds.length > 0 && pageIds.every((id) => selectedInvoiceIds.includes(id));
    setSelectAllChecked(allSelected);
  }, [selectedInvoiceIds, filteredinvoiceData, currentPage, pageLimit]);

  // Table's client-side pagination — just track page/limit for the next API call context
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSelectedInvoiceIds([]);
    setSelectAllChecked(false);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setPageLimit(newLimit);
    setCurrentPage(page);
  };

  // Confirmation modal openers
  const openConfirmSingle = (row) => {
    setConfirmTarget({ type: "single", ids: [row.ID], invoiceNos: [row.No] });
    setShowConfirmModal(true);
  };

  const openConfirmBulk = () => {
    if (selectedInvoiceIds.length === 0) return;
    const invoiceNos = filteredinvoiceData
      .filter((r) => selectedInvoiceIds.includes(r.ID))
      .map((r) => r.No);
    setConfirmTarget({ type: "bulk", ids: selectedInvoiceIds, invoiceNos });
    setShowConfirmModal(true);
  };

  const closeConfirmModal = () => {
    if (isProcessingInvoices) return;
    setShowConfirmModal(false);
    setConfirmTarget(null);
  };

  const handleProcessInvoices = async () => {
    if (!confirmTarget || confirmTarget.ids.length === 0) return;
    setIsProcessingInvoices(true);

    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token") || "");
      formData.append("invoice_id", JSON.stringify(confirmTarget.ids));

      const res = await axios.post("/expo_access_api/processDCInv/", formData);
      const payload = res?.data;

      // ─── Dynamic response normalizer (handles object OR array envelope) ───
      let status, msg, source, details;
      if (Array.isArray(payload) && payload.length > 0) {
        status = payload[0]?.STATUS;
        msg = payload[0]?.MSG;
        source = payload[0]?.SOURCE;
        details = payload[0]?.DATA;
      } else if (payload && typeof payload === "object") {
        status = payload.STATUS;
        msg = payload.MSG;
        source = payload.SOURCE;
        details = payload.DATA;
      } else {
        throw new Error("Invalid response from server");
      }
      // ─────────────────────────────────────────────────────────────────────

      if (status === "SUCCESS") {
        toast.success(msg || `${confirmTarget.ids.length} invoice(s) processed successfully!`, {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });
        setShowConfirmModal(false);
        setConfirmTarget(null);
        setSelectedInvoiceIds([]);
        setSelectAllChecked(false);
        const dateParams = getDateParams();
        fetchTransactionList(dateParams, null, "pending", currentPage, pageLimit);
        return;
      }

      // ─── ERROR: Build dynamic error payload ──────────────────────────────
      const isDetailArray =
        Array.isArray(details) &&
        details.length > 0 &&
        details.every((i) => i && typeof i === "object" && !Array.isArray(i));

      setErrorPayload({
        title: msg || "Processing Failed",
        message: msg || "Failed to process invoice(s)",
        source: source || "processDCInv",
        details: details,
        isDetailArray,
      });

      setShowConfirmModal(false); // close confirm so error modal is visible
      setConfirmTarget(null);
      setShowErrorModal(true);
    } catch (error) {
      console.error("Process invoice error:", error);
      toast.error(error.message || "Error processing invoice(s)", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setIsProcessingInvoices(false);
    }
  };

  const invoiceColumns = [
    {
      name: "Invoice No.",
      selector: (row) => row?.No,
      sortable: true,
      center: true,
      minWidth: "180px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "180px" }}
          title={row?.No || ""}
        >
          {row?.No || "N/A"}
        </div>
      ),
    },
    {
      name: "Date",
      selector: (row) => row?.Date,
      sortable: true,
      center: true,
      minWidth: "80px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "80px" }}
          title={row?.Date || ""}
        >
          {row?.Date || "N/A"}
        </div>
      ),
    },
    {
      name: "Branch",
      selector: (row) => row?.b_name,
      sortable: true,
      center: true,
      minWidth: "140px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "140px" }}
          title={row?.b_name || ""}
        >
          {row?.b_name || "N/A"}
        </div>
      ),
    },
    {
      name: "Contact",
      selector: (row) => row?.Name,
      sortable: true,
      center: true,
      minWidth: "220px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{
            maxWidth: "220px",
            textAlign: "start"
          }}
          title={row?.Name ? row.Name.replace(/\+/g, " ") : "N/A"}
        >
          {row?.Name ? row.Name.replace(/\+/g, " ") : "N/A"}
        </div>
      ),
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.Mobile,
      sortable: true,
      center: true,
      width: "150px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "150px" }}
          title={row?.Mobile || ""}
        >
          {row?.Mobile || "N/A"}
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => row?.Amount,
      sortable: true,
      center: true,
      minWidth: "100px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "100px" }}
          title={`₹ ${row?.Amount || "0"}`}
        >
          {formatCurrency(row?.Amount, 'IN', 'INR')}
        </div>
      ),
    },
    {
      name: "Share",
      cell: (row) => (
        <button
          onClick={() => handleWhatsAppClick(row)}
          disabled={isLoading}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: isLoading
              ? "#ccc"
              : row.create_from == 0
                ? "#FFF"
                : row.create_from == 1
                  ? "#26994e"
                  : "#26994e",
            fontSize: "24px",
          }}
          title="Send via WhatsApp"
          className="text-wrap overflow-hidden"
        >
          <FaWhatsapp />
        </button>
      ),
      center: true,
      minWidth: "80px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const pendingInvoiceColumns = [
    {
      name: (
        <input
          type="checkbox"
          checked={selectAllChecked}
          onChange={handleSelectAll}
          aria-label="Select all invoices"
        />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedInvoiceIds.includes(row.ID)}
          onChange={() => handleSelectRow(row.ID)}
          aria-label={`Select invoice ${row.No}`}
        />
      ),
      width: "50px",
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    ...invoiceColumns,
    {
      name: "Action",
      cell: (row) => (
        <Button
          size="sm"
          className="process-btn"
          onClick={() => openConfirmSingle(row)}
          disabled={isProcessingInvoices}
        >
          Process
        </Button>
      ),
      center: true,
      minWidth: "110px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const processedInvoiceColumns = [
    ...invoiceColumns,
    // {
    //   name: "Status",
    //   cell: () => <Badge bg="success">Processed</Badge>,
    //   center: true,
    //   minWidth: "110px",
    // },
  ];

  const productColumns = [
    {
      name: "Product Code",
      selector: (row) => row.product_code,
      sortable: true,
      center: true,
      minWidth: "150px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "150px" }}
          title={row?.product_code || ""}
        >
          {row?.product_code || "N/A"}
        </div>
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
      center: true,
      minWidth: "200px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "200px", textAlign: "start" }}
          title={row?.product_name || ""}
        >
          {row?.product_name || "N/A"}
        </div>
      ),
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
      minWidth: "100px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "100px", color: "#28a745", fontWeight: "bold" }}
          title={
            row?.quantity
              ? `${formatQty(row.quantity)}${row.product_first_unit ? " " + row.product_first_unit : ""}`
              : "0"
          }
        >
          {formatQty(row?.quantity)}
          {row?.product_first_unit ? ` ${row.product_first_unit}` : ""}
        </div>
      ),
    },
  ];

  // Product Movement Columns
  const productMovementColumns = [
    {
      name: "Product Code",
      selector: (row) => row.product_code,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "120px" }}
          title={row?.product_code || ""}
        >
          {row?.product_code || "N/A"}
        </div>
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
      center: true,
      minWidth: "200px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "200px", textAlign: "start" }}
          title={row?.product_name || ""}
        >
          {row?.product_name || "N/A"}
        </div>
      ),
    },
    {
      name: "Inward Quantity",
      selector: (row) => row.inward_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#28a745", fontWeight: "bold" }}>
          {formatQty(row.inward_qty)}
          {row?.product_first_unit ? ` ${row.product_first_unit}` : ""}
        </span>
      ),
    },
    {
      name: "Outward Quantity",
      selector: (row) => row.outward_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#dc3545", fontWeight: "bold" }}>
          {formatQty(row.outward_qty)}
          {row?.product_first_unit ? ` ${row.product_first_unit}` : ""}
        </span>
      ),
    },
    {
      name: "Balance Quantity",
      selector: (row) => row.remaining_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#007bff", fontWeight: "bold" }}>
          {formatQty(row.remaining_qty)}
          {row?.product_first_unit ? ` ${row.product_first_unit}` : ""}
        </span>
      ),
    },
  ];

  //Added by Akshar for Background Color for TR
  // Define conditional row styles
  const conditionalRowStyles = [
    {
      when: (row) => row.create_from == 0, // Condition for create_from: 0
      style: {
        backgroundColor: "#007c41 !important", // Light red background
        color: "#fff !important", // Darker text color for contrast
      },
    },
    {
      when: (row) => row.create_from == 1, // Condition for create_from: 1
      style: {
        backgroundColor: "#f5f4ef !important", // Light green background
        color: "#098048 !important", // Darker text color for contrast
      },
    },
  ];

  // Format API response to match template structure
  const formatInvoiceData = (apiData) => ({
    ...apiData,
    Invoice_fullno: apiData.fullinvoiceno,
    contact_name: apiData.contact_name,
    contact_number: apiData.mobile_no,
    currenttodaydate: apiData.invoice_dt,
    cart: apiData.products.map((product) => ({
      product_id: product.id || Math.random().toString(36).substr(2, 9),
      name: product.name,
      quantity: product.quantity,
      subT: product.price * product.quantity,
      price: product.price,
      // primary_unit: product.primary_unit,
      // secondary_unit: product.secondary_unit,
      // conversion_flg: product.conversion_flg,
    })),
    billSummary: {
      actualTotalPrice: (parseFloat(apiData.total_amount) || 0).toFixed(2),
      totalDiscount: (parseFloat(apiData.total_discount) || 0).toFixed(2),
      totalTaxes: (parseFloat(apiData.total_tax) || 0).toFixed(2),
      grandTotal: (parseFloat(apiData.grand_total) || 0).toFixed(2),
      roundoff: apiData.roundoff,   // keep raw — drives Add/Deduct sign
    },
  });

  // Fetch invoice data from API
  const fetchInvoiceData = async (invoiceId) => {
    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("invoice_id", invoiceId);

      const response = await fetch(
        `${baseurl}/expo_access_api/getInvoiceProductData/`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result?.STATUS === "SUCCESS" && result?.DATA) {
        return formatInvoiceData(result?.DATA);
      }
      throw new Error("Failed to fetch invoice data");
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  };

  // Handle WhatsApp click
  const handleWhatsAppClick = async (row) => {
    try {
      setIsLoading(true);
      const data = await fetchInvoiceData(row?.ID);
      await generatePDF(data);
    } catch (error) {
      toast.error(error.message || "Error processing invoice", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Generate PDF and send to WhatsApp (now accepts invoiceData parameter)
  const generatePDF = async (invoiceData) => {
    if (!invoiceData) return;

    let originalStyles = {};

    try {
      setIsLoading(true);
      window.html2canvas = html2canvas;

      setCurrentInvoice(invoiceData);

      const element = document.querySelector("#rep1");

      originalStyles = {
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        visibility: element.style.visibility,
      };

      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.visibility = "visible";

      await new Promise((resolve) => setTimeout(resolve, 150));

      const pdf = new jsPDF("p", "mm", "a4");

      const canvas = await html2canvas(element, {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight, undefined, "FAST");

      const blobPDF = new Blob([pdf.output("blob")], {
        type: "application/pdf",
      });

      await sendPDFToWhatsApp(blobPDF, invoiceData);
      setCurrentInvoice(null);
    } catch (error) {
      console.error("PDF generation error:", error);
      setCurrentInvoice(null);
      toast.error(
        error?.message || "Failed to send invoice via WhatsApp. Please try again.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    } finally {
      const element = document.querySelector("#rep1");
      if (element) {
        element.style.position = originalStyles.position || "";
        element.style.left = originalStyles.left || "";
        element.style.top = originalStyles.top || "";
        element.style.visibility = originalStyles.visibility || "hidden";
      }
      setIsLoading(false);
    }
  };

  // Send PDF to WhatsApp API (now accepts invoiceData parameter)
  const sendPDFToWhatsApp = async (pdfBlob, invoiceData) => {
    try {
      const message = `Hi ${invoiceData.contact_name}, Attached is your invoice. Let me know if you need anything else.`;
      const formData = new FormData();
      formData.append("image", pdfBlob);
      formData.append("invoice_id", invoiceData.invoice_id || "");
      formData.append("contact_id", invoiceData.contact_id || "");
      formData.append("countrycode", 91);
      formData.append("mobileno", invoiceData.contact_number || "");
      formData.append("wp_clientmsg", message);
      formData.append("contactType", invoiceData.type || "");
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token") || "");

      // ─── Pre-flight validations ──────────────────────────────────────
      const missingFields = [];
      if (!formData.get("invoice_id")) missingFields.push("Invoice No");
      if (!formData.get("contact_id")) missingFields.push("Contact");
      if (!formData.get("mobileno")) missingFields.push("Mobile Number");

      if (missingFields.length > 0) {
        throw new Error(
          `Cannot send WhatsApp: Missing ${missingFields.join(", ")}.`
        );
      }

      // ─── API call ────────────────────────────────────────────────────
      const response = await fetch(
        `${baseurl}/expo_access_api/invoicePdfsendfdtowhatsapp/`,
        { method: "POST", body: formData }
      );

      // Handle HTTP errors (network down, 500, 404, etc.)
      if (!response.ok) {
        let errorMsg = `Server returned ${response.status} (${response.statusText})`;
        try {
          const errorData = await response.json();
          if (errorData?.[0]?.MSG) errorMsg = errorData[0].MSG;
        } catch {
          // response body is not JSON — keep generic message
        }
        throw new Error(errorMsg);
      }

      // ─── Parse JSON response ───────────────────────────────────────
      let apiResponse;
      try {
        apiResponse = await response.json();
      } catch {
        throw new Error("Invalid response from server. Please try again.");
      }

      // ─── Handle API-level errors ───────────────────────────────────
      const apiStatus = apiResponse?.[0]?.STATUS;
      const apiMessage = apiResponse?.[0]?.MSG || "Unknown error";

      if (apiStatus === "ERROR") {
        throw new Error(apiMessage);
      }

      if (apiStatus !== "SUCCESS") {
        throw new Error(apiMessage);
      }

      // ─── Success ───────────────────────────────────────────────────
      toast.success("Invoice sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error("WhatsApp send error:", error);
      throw error; // Re-throw so generatePDF can handle UI cleanup
    }
  };

  // Fetch Top Products with date filter using FormData
  const fetchTopProducts = async (dateParams = null, branchOverride = null) => {
    setLoadingProducts(true);
    try {
      const params = dateParams || getDateParams();
      const branch = branchOverride !== null ? branchOverride : selectedBranch;

      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("start_dt", params.start_dt);
      formData.append("end_dt", params.end_dt);
      formData.append("branch_id", branch || "");

      const res = await axios.post("/ecommerce_api/getSellingTopProducts", formData);

      const { data } = res;

      if (data && data?.STATUS === "SUCCESS" && data?.DATA) {
        setTopProducts(data.DATA);
        setFilteredTopProducts(data.DATA);
        setProductsInfo("");
      } else {
        setProductsInfo(data?.MSG || "Data Not Found");
        setTopProducts([]);
        setFilteredTopProducts([]);
      }
    } catch (error) {
      console.error("Error fetching top products:", error);
      setProductsInfo("Data Not Found");
      setTopProducts([]);
      setFilteredTopProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  // Rows visible on the current page (client-side pagination slice)
  const getCurrentPageRows = (data) => {
    const start = (currentPage - 1) * pageLimit;
    return data.slice(start, start + pageLimit);
  };

  // Fetch Transaction List with date filter
  const fetchTransactionList = async (
    dateParams = null,
    branchOverride = null,
    tabOverride = null,
    page = null,
    limit = null
  ) => {
    setLoadingInvoices(true);
    try {
      const params = dateParams || getDateParams();
      const branch = branchOverride !== null ? branchOverride : selectedBranch;
      const tab = tabOverride !== null ? tabOverride : invoiceTab;
      // const pageNo = page !== null ? page : currentPage;
      // const limitNo = limit !== null ? limit : pageLimit;

      // Only page/limit go to API — is_pos_invoice is NOT sent
      const res = await axios.post("/expo_access_api/getTransactionList", {
        AUTHORIZEKEY: process.env.REACT_APP_AUTHORIZE_KEY,
        start_dt: params.start_dt,
        end_dt: params.end_dt,
        branch_id: branch || "",
        // page: pageNo,
        // limit: limitNo,
      });

      const { data } = res;

      if (data && data[0]?.DATA?.invoiceList) {
        const message = data[0].MSG;
        const list = data[0].DATA.invoiceList;

        // Split by is_pos_invoice: "1" => Pending, "0" => Processed
        // const filteredByStatus = list.filter((inv) =>
        //   tab === "pending"
        //     ? String(inv.is_pos_invoice) === "1"
        //     : String(inv.is_pos_invoice) === "0"
        // );

        const filteredByStatus = list.filter((inv) => {
          const isPos = String(inv.is_pos_invoice) === "1";
          const isClosed = inv.status_flg === "CL";

          if (tab === "pending") {
            // Day End Process: POS invoice that is NOT closed (status_flg = "A")
            return isPos && !isClosed;
          } else {
            // Regular: Non-POS OR already closed (any status_flg = "CL")
            return !isPos || isClosed;
          }
        });

        setDatainfo(message);
        setInvoiceData(filteredByStatus);
        setFilteredInvoiceData(filteredByStatus);
        setInvoiceinfo(data[0]?.DATA);
      } else {
        const message = data?.[0]?.MSG || "Data Not Found";
        setDatainfo(message);
        setInvoiceData([]);
        setFilteredInvoiceData([]);
        setInvoiceinfo({});
      }

      setSelectedInvoiceIds([]);
      setSelectAllChecked(false);
    } catch (error) {
      console.error("Error fetching transaction list:", error);
      setDatainfo("Data Not Found");
      setInvoiceData([]);
      setFilteredInvoiceData([]);
      setInvoiceinfo({});
    } finally {
      setLoadingInvoices(false);
    }
  };

  // Fetch Product Movement Data with date filter
  const fetchProductMovement = async (dateParams = null, branchOverride = null) => {
    setLoadingProductMovement(true);
    try {
      const params = dateParams || getDateParams();
      const branch = branchOverride !== null ? branchOverride : selectedBranch;

      const res = await axios.post("/ecommerce_api/getProductMovement", {
        AUTHORIZEKEY: process.env.REACT_APP_AUTHORIZE_KEY,
        start_dt: params.start_dt,
        end_dt: params.end_dt,
        branch_id: branch || "",
      });

      const { data } = res;

      if (data && data?.STATUS === "SUCCESS" && data?.DATA) {
        const formattedData = data.DATA.map(item => ({
          ...item,
          inward_qty: item.inward_qty,
          outward_qty: item.outward_qty,
          remaining_qty: item.remaining_qty
        }));

        setProductMovementData(formattedData);
        setFilteredProductMovementData(formattedData);
        setProductMovementInfo("");
      } else {
        setProductMovementInfo(data?.MSG || "Data Not Found");
        setProductMovementData([]);
        setFilteredProductMovementData([]);
      }
    } catch (error) {
      console.error("Error fetching product movement:", error);
      setProductMovementInfo("Data Not Found");
      setProductMovementData([]);
      setFilteredProductMovementData([]);
    } finally {
      setLoadingProductMovement(false);
    }
  };

  // Handle Search button click
  const handleSearch = () => {
    const dateParams = getDateParams();

    if ((selectedView === "products" || selectedView === "movement") && !selectedBranch) {
      toast.error("Please select a branch.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    switch (selectedView) {
      case "invoice":
        fetchTransactionList(dateParams, null, invoiceTab, 1, pageLimit);
        break;
      case "products":
        fetchTopProducts(dateParams);
        break;
      case "movement":
        fetchProductMovement(dateParams);
        break;
      default:
        break;
    }
  };

  // Handle Reset button click
  const handleReset = () => {
    const today = getTodayDate();
    setFromDate(today);
    setToDate(today);
    setSearchtext("");
    setSelectedBranch("");

    const todayDateParams = getTodayDateParams();

    if (selectedView === "invoice") {
      fetchTransactionList(todayDateParams, "", invoiceTab, 1, pageLimit);
    } else if (selectedView === "products") {
      setProductsInfo("Please select a branch");
      setTopProducts([]);
      setFilteredTopProducts([]);
    } else if (selectedView === "movement") {
      setProductMovementInfo("Please select a branch");
      setProductMovementData([]);
      setFilteredProductMovementData([]);
    }
  };

  // Handle view change
  const handleViewChange = (e) => {
    const newView = e.target.value;
    setSelectedView(newView);
    setSearchtext("");

    const dateParams = getDateParams();

    if (newView === "invoice") {
      fetchTransactionList(dateParams);
    } else if (newView === "products") {
      if (!selectedBranch) {
        setProductsInfo("Please select a branch");
        setTopProducts([]);
        setFilteredTopProducts([]);
      } else {
        fetchTopProducts(dateParams);
      }
    } else if (newView === "movement") {
      if (!selectedBranch) {
        setProductMovementInfo("Please select a branch");
        setProductMovementData([]);
        setFilteredProductMovementData([]);
      } else {
        fetchProductMovement(dateParams);
      }
    }
  };

  // Handle text search
  const handleTextSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchtext(searchValue);

    const filterData = (data) => {
      return data.filter((item) => {
        return Object.keys(item).some((key) => {
          if (item[key] && typeof item[key] === "string") {
            const cleanedItem = item[key]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "")
              .replace(/\s+/g, " ")
              .trim();
            const cleanedSearchValue = searchValue
              .replace(/[^a-z0-9]+/g, "")
              .replace(/\s+/g, " ")
              .trim();

            return cleanedItem.includes(cleanedSearchValue);
          }
          return false;
        });
      });
    };

    if (selectedView === "invoice") {
      const filteredItems = filterData(invoiceData);
      setFilteredInvoiceData(filteredItems);
      setCurrentPage(1);
      setSelectedInvoiceIds([]);
      setSelectAllChecked(false);
    } else if (selectedView === "products") {
      const filteredItems = filterData(topProducts);
      setFilteredTopProducts(filteredItems);
    } else if (selectedView === "movement") {
      const filteredItems = filterData(productMovementData);
      setFilteredProductMovementData(filteredItems);
    }
  };

  // Initialize component
  useEffect(() => {
    setInitialDates();
    fetchBranches();
    const todayDateParams = getTodayDateParams();
    fetchTransactionList(todayDateParams, null, "processed", 1, pageLimit);
  }, []);

  return (
    <>
      <div className="dashboardposmain">
        <div className="grid-container-dashboard ">
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round primary`}>
                    <div className="bg-round">
                      <LiaFileInvoiceSolid color="#7366ff" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.total_invoice}
                      />
                    </H4>
                    <span className="f-light">Total Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round warning`}>
                    <div className="bg-round">
                      <MdOutlineCancel color="#ffaa05" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.cancel_invoice}
                      />
                    </H4>
                    <span className="f-light">Cancel Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round secondary`}>
                    <div className="bg-round">
                      <IoLockClosedOutline color="#d63384" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.close_invoice}
                      />
                    </H4>
                    <span className="f-light">Close Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round success`}>
                    <div className="bg-round">
                      <GoIssueClosed color="#54ba4a" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.paid_invoice}
                      />
                    </H4>
                    <span className="f-light">Paid Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>

        <Row>
          <Col sm="12">
            <Card>
              {isLoading && (
                <div className="text-center timesheet-label mt-3">
                  Please wait while sending the invoice...
                </div>
              )}
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div style={{ width: '200px' }}></div>
                  <div className="export-new">
                    <Button
                      className="searchbtn"
                      onClick={handleComposeButtonClick}
                    >
                      Create Invoice
                    </Button>
                  </div>
                </div>

                <div className="my-2">
                  {/* Date Filter Section - Centered */}
                  <div className="row mb-3 align-items-end justify-content-center">
                    <div className="col-md-4 col-sm-6">
                      <label htmlFor="fromDate" className="form-label fw-bold">From Date</label>
                      <Input
                        type="date"
                        id="fromDate"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <label htmlFor="toDate" className="form-label fw-bold">To Date</label>
                      <Input
                        type="date"
                        id="toDate"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        min={fromDate}
                      />
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <label htmlFor="branchSelect" className="form-label fw-bold">Branch</label>
                      <Input
                        type="select"
                        id="branchSelect"
                        className="form-control"
                        value={selectedBranch}
                        onChange={(e) => setSelectedBranch(e.target.value)}
                      >
                        {selectedView === "invoice" ? (
                          <option value="">-- All Branches --</option>
                        ) : (
                          <option value="">-- Select Branch --</option>
                        )}
                        {Array.isArray(branch_arr) &&
                          branch_arr.map((br, i) => (
                            <option value={br.branch_id} key={i}>
                              {br.name}
                            </option>
                          ))}
                      </Input>
                    </div>
                  </div>

                  {/* Search and Reset Buttons Row - Centered */}
                  <div className="row mb-3 align-items-end justify-content-center">
                    <div className="col-md-4">
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          className="searchbtn"
                          onClick={handleSearch}
                          disabled={loadingInvoices || loadingProducts || loadingProductMovement}
                          style={{ minWidth: '120px' }}
                        >
                          Search
                        </Button>
                        <Button
                          variant="outline-secondary"
                          onClick={handleReset}
                          disabled={loadingInvoices || loadingProducts || loadingProductMovement}
                          style={{ minWidth: '120px' }}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* Search and View Type Section - Justify between */}
                  <div className="row mb-3 align-items-end justify-content-between">
                    <div className="col-md-6">
                      <Input
                        id="searchText"
                        className="form-control register-full input-register"
                        type="text"
                        placeholder="Search across all fields..."
                        value={searchtext}
                        onChange={handleTextSearch}
                        style={{ maxWidth: "320px" }}
                      />
                    </div>
                    {!(selectedView === "invoice" && invoiceTab === "pending") && (
                      <div className="col-md-3">
                        <Input
                          type="select"
                          id="viewSelect"
                          value={selectedView}
                          onChange={handleViewChange}
                          className="form-control register-full input-register"
                        >
                          <option value="invoice">Invoicewise Sales</option>
                          <option value="products">Productwise Sales</option>
                          <option value="movement">Product Movement</option>
                        </Input>
                      </div>
                    )}
                  </div>

                  {selectedView === "invoice" ? (
                    <>
                      {/* Pending / Processed Tabs */}
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        {withoutstockbypass && (
                          <div className="invoice-tabs d-flex" role="tablist">
                            {/* First tab = Regular Invoices (processed key) */}
                            <button
                              type="button"
                              className={`invoice-tab-btn ${invoiceTab === "processed" ? "active" : ""}`}
                              onClick={() => handleInvoiceTabChange("processed")}
                            >
                              Regular Invoices
                            </button>

                            {/* Second tab = Day End Process Invoices (pending key) */}
                            <button
                              type="button"
                              className={`invoice-tab-btn ${invoiceTab === "pending" ? "active" : ""}`}
                              onClick={() => handleInvoiceTabChange("pending")}
                            >
                              Day End Process Invoices
                            </button>
                          </div>
                        )}

                        {invoiceTab === "pending" && withoutstockbypass && (
                          <div className="d-flex align-items-center gap-2">
                            {selectedInvoiceIds.length > 0 && (
                              <span className="text-muted small">
                                {selectedInvoiceIds.length} selected
                              </span>
                            )}
                            <Button
                              className="searchbtn"
                              onClick={openConfirmBulk}
                              disabled={selectedInvoiceIds.length === 0 || isProcessingInvoices}
                            >
                              Process Selected
                            </Button>
                          </div>
                        )}
                      </div>

                      {loadingInvoices ? (
                        <div className="text-center mt-3">
                          <Spinner animation="border" variant="success" />
                        </div>
                      ) : data_info === "Data Not Found" || invoiceData.length === 0 ? (
                        <div className="text-center mt-3 py-3" style={{ backgroundColor: "#dfdcdc" }}>
                          No Records found
                        </div>
                      ) : (
                        <>
                          <DataTable
                            data={filteredinvoiceData}
                            columns={withoutstockbypass ? (invoiceTab === "pending" ? pendingInvoiceColumns : processedInvoiceColumns) : processedInvoiceColumns}
                            striped
                            center
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={withoutstockbypass ? [10] : [10, 25, 50, 100]}
                            paginationComponentOptions={{ noRowsPerPage: withoutstockbypass }}
                            onChangePage={handlePageChange}
                            conditionalRowStyles={conditionalRowStyles}
                            className="pos-dashboard-table"
                          />
                          {withoutstockbypass && (
                            <div className="row justify-content-end">
                              <div className="col-md-4">
                                <div className="d-flex justify-content-between align-items-center">
                                  <strong className="text-dark">Page Total:</strong>
                                  <strong className="text-success" style={{ fontSize: "1.2rem" }}>
                                    {formatCurrency(
                                      calculateTotalAmount(getCurrentPageRows(filteredinvoiceData)),
                                      "IN",
                                      "INR"
                                    )}
                                  </strong>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            className="total-amount-section mt-3 p-3"
                            style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: "5px" }}
                          >
                            <div className="row justify-content-end">
                              <div className="col-md-4">
                                <div className="d-flex justify-content-between align-items-center">
                                  <strong className="text-dark">Total Amount:</strong>
                                  <strong className="text-success" style={{ fontSize: "1.2rem" }}>
                                    {formatCurrency(calculateTotalAmount(filteredinvoiceData), "IN", "INR")}
                                  </strong>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : selectedView === "products" ? (
                    loadingProducts ? (
                      <div className="text-center mt-3">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : topProducts.length === 0 ? (
                      <div className="text-center mt-3 py-3" style={{ backgroundColor: "#dfdcdc" }}>
                        {productsInfo === "Please select a branch"
                          ? "Please select a branch to view product-wise sales"
                          : "No Records found"}
                      </div>
                    ) : (
                      <DataTable
                        data={filteredTopProducts}
                        columns={productColumns}
                        striped={true}
                        center={true}
                        pagination
                        className="pos-dashboard-table"
                      />
                    )
                  ) : (
                    // Product Movement View
                    loadingProductMovement ? (
                      <div className="text-center mt-3">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : productMovementData.length === 0 ? (
                      <div className="text-center mt-3 py-3" style={{ backgroundColor: "#dfdcdc" }}>
                        {productMovementInfo === "Please select a branch"
                          ? "Please select a branch to view product movement"
                          : "No Records found"}
                      </div>
                    ) : (
                      <DataTable
                        data={filteredProductMovementData}
                        columns={productMovementColumns}
                        striped={true}
                        center={true}
                        pagination
                        className="pos-dashboard-table"
                      />
                    )
                  )}
                </div>
              </CardBody>
              {isLoading && (
                <div className="text-center timesheet-label mb-3">
                  Please wait while sending the invoice...
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      {/* Hidden invoice template */}
      <div>
        <div
          className="d-flex justify-content-center align-items-center"
          ref={componentRef}
          id="rep1"
          style={{
            width: "210mm",
            minHeight: "auto",
            padding: "20px",
            backgroundColor: "white",
            boxSizing: "border-box",
            visibility: "hidden",
            position: "absolute",
          }}
        >
          <div
            className="receipt"
            style={{
              width: "100%",
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              color: "#1f2937",
              fontSize: "12px",
              lineHeight: 1.35,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1.5px solid #111827",
                paddingTop: "6px",        // ✅ adds space above INVOICE
                paddingBottom: "8px",
                marginBottom: "10px",
              }}
            >
              <img
                src={`${baseurl}${image_url_logo}`}
                alt="Company Logo"
                style={{ maxHeight: "44px", objectFit: "contain" }}
              />
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "0.5px", color: "#111827" }}>
                  INVOICE
                </div>
                <div style={{ color: "#6b7280", fontSize: "11px" }}>{currentInvoice?.Invoice_fullno}</div>
                <div style={{ color: "#6b7280", fontSize: "11px" }}>{currentInvoice?.currenttodaydate}</div>
              </div>
            </div>

            <div style={{ marginBottom: "10px", fontSize: "12px" }}>
              <span style={{ color: "#9ca3af", textTransform: "uppercase", fontSize: "10px", letterSpacing: "0.5px" }}>
                Billed To:{" "}
              </span>
              <span style={{ fontWeight: 600 }}>{currentInvoice?.contact_name}</span>
              <span style={{ color: "#6b7280" }}> · {currentInvoice?.contact_number}</span>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
              <thead>
                <tr style={{ backgroundColor: "#111827", color: "#ffffff" }}>
                  <th style={{ textAlign: "left", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600 }}>Item</th>
                  <th style={{ textAlign: "center", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600, width: "60px" }}>Qty</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.4px", fontWeight: 600, width: "100px" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {currentInvoice?.cart?.map((item, idx) => (
                  <tr key={item?.product_id || idx} style={{ backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9fafb" }}>
                    <td style={{ padding: "4px 8px", borderBottom: "1px solid #f0f0f0" }}>{item?.name}</td>
                    <td style={{ padding: "4px 8px", textAlign: "center", borderBottom: "1px solid #f0f0f0" }}>{item?.quantity}</td>
                    <td style={{ padding: "4px 8px", textAlign: "right", borderBottom: "1px solid #f0f0f0" }}>
                      <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                      {item?.price?.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <table style={{ width: "240px", borderCollapse: "collapse", fontSize: "12px" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "3px 0", color: "#6b7280" }}>Gross Amount</td>
                    <td style={{ padding: "3px 0", textAlign: "right" }}>
                      <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                      {currentInvoice?.billSummary?.actualTotalPrice}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "3px 0", color: "#6b7280" }}>Discount</td>
                    <td style={{ padding: "3px 0", textAlign: "right", color: "#c0392b" }}>
                      − <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                      {currentInvoice?.billSummary?.totalDiscount}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "3px 0", color: "#6b7280" }}>Taxes</td>
                    <td style={{ padding: "3px 0", textAlign: "right" }}>
                      + <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                      {currentInvoice?.billSummary?.totalTaxes}
                    </td>
                  </tr>
                  {(parseFloat(currentInvoice?.billSummary?.roundoff) || 0) !== 0 && (
                    <tr>
                      <td style={{ padding: "3px 0", color: "#6b7280" }}>
                        Adjustment ({parseFloat(currentInvoice?.billSummary?.roundoff) < 0 ? "Deduct" : "Add"})
                      </td>
                      <td style={{ padding: "3px 0", textAlign: "right" }}>
                        {parseFloat(currentInvoice?.billSummary?.roundoff) < 0 ? "− " : "+ "}
                        <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                        {Math.abs(parseFloat(currentInvoice?.billSummary?.roundoff) || 0).toFixed(2)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ padding: "6px 0 0", borderTop: "1.5px solid #111827", fontWeight: 700, fontSize: "13px" }}>
                      Total Payable
                    </td>
                    <td style={{ padding: "6px 0 0", borderTop: "1.5px solid #111827", textAlign: "right", fontWeight: 700, fontSize: "13px", color: "#15803d" }}>
                      <span style={{ color: "#9ca3af", fontSize: "10px" }}>INR </span>
                      {currentInvoice?.billSummary?.grandTotal}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: "14px", paddingTop: "8px", borderTop: "1px solid #e5e7eb", textAlign: "center", color: "#9ca3af", fontSize: "11px" }}>
              Thank you for your business!
            </div>
          </div>
        </div>
      </div>

      {/* Replace this entire block */}
      <Modal isOpen={showConfirmModal} toggle={closeConfirmModal} centered>
        <ModalHeader toggle={!isProcessingInvoices ? closeConfirmModal : undefined}>
          Confirm Processing
        </ModalHeader>
        <ModalBody>
          {confirmTarget?.type === "bulk" ? (
            <p>
              Are you sure you want to process <strong>{confirmTarget.ids.length}</strong> selected invoice(s)?
            </p>
          ) : (
            <p>
              Are you sure you want to process invoice{" "}
              <strong>{confirmTarget?.invoiceNos?.[0]}</strong>?
            </p>
          )}
          {confirmTarget?.invoiceNos?.length > 0 && (
            <div
              className="d-flex flex-wrap gap-2 mt-3 p-2"
              style={{
                maxHeight: "140px",
                overflowY: "auto",
                backgroundColor: "#f8f9fa",
                borderRadius: "6px",
                border: "1px solid #e9ecef",
              }}
            >
              {confirmTarget.invoiceNos.map((invNo) => (
                <span
                  key={invNo}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "4px 10px",
                    backgroundColor: "#e7f1ff",
                    color: "#0d6efd",
                    border: "1px solid #b6d4fe",
                    borderRadius: "16px",
                    fontSize: "13px",
                    fontWeight: 600,
                    letterSpacing: "0.3px",
                  }}
                >
                  {invNo}
                </span>
              ))}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="outline-secondary" onClick={closeConfirmModal} disabled={isProcessingInvoices}>
            Cancel
          </Button>
          <Button className="searchbtn" onClick={handleProcessInvoices} disabled={isProcessingInvoices}>
            {isProcessingInvoices ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Processing...
              </>
            ) : (
              "Confirm"
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Professional Error Detail Modal */}
      <Modal
        isOpen={showErrorModal}
        toggle={closeErrorModal}
        centered
        size={errorPayload?.isDetailArray ? "lg" : "md"}
        backdrop="static"
      >
        <ModalHeader
          toggle={closeErrorModal}
          className="border-bottom-0 pb-0"
          style={{ backgroundColor: "transparent" }}
        >
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#fff8e1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#f59e0b",
              }}
            >
              <IoAlertCircleOutline size={22} />
            </div>
            <div>
              <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: 600, color: "#1f2937" }}>
                {errorPayload?.title || "Unable to Process"}
              </h5>
              {/* <span className="text-muted" style={{ fontSize: "12px" }}>
          {errorPayload?.source || "processDCInv"}
        </span> */}
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="pt-3">
          {/* <p style={{ fontSize: "14px", color: "#4b5563", marginBottom: "16px" }}>
            {errorPayload?.message || "An unexpected error occurred while processing the invoice(s)."}
          </p> */}

          {errorPayload?.isDetailArray ? (
            <>
              <div
                className="d-flex align-items-center gap-2 mb-3 p-2 rounded"
                style={{
                  backgroundColor: "#e6f4ef",
                  border: "1px solid #007c41",
                }}
              >
                <IoAlertCircleOutline size={18} color="#007c41" />
                <span style={{ fontSize: "13px", color: "#007c41", fontWeight: 600 }}>
                  {(errorPayload.details[0]?.branch_name || errorPayload.details[0]?.b_name || errorPayload.details[0]?.branch)
                    ? "Please add the highlighted Need Qty to stock for the respective branches below."
                    : "Please add the highlighted Need Qty values to stock."}
                </span>
              </div>

              <div
                className="table-responsive"
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <table className="table table-sm mb-0" style={{ fontSize: "13px" }}>
                  <thead>
                    <tr>
                      {Object.keys(errorPayload.details[0]).map((key) => {
                        const isNeedQty = key === "need_qty";
                        const isBranch = key === "branch_name" || key === "b_name" || key === "branch";
                        return (
                          <th
                            key={key}
                            style={{
                              padding: "10px 14px",
                              fontWeight: 600,
                              textTransform: "capitalize",
                              whiteSpace: "nowrap",
                              borderBottom: "1px solid #e5e7eb",
                              backgroundColor: isNeedQty ? "#007c41" : isBranch ? "#f0fdf4" : "#f9fafb",
                              color: isNeedQty ? "#ffffff" : isBranch ? "#007c41" : "#374151",
                              fontSize: isNeedQty ? "14px" : "13px",
                            }}
                          >
                            {key.replace(/_/g, " ")}
                            {isNeedQty && (
                              <span style={{ marginLeft: "4px", fontSize: "11px" }}>●</span>
                            )}
                            {isBranch && (
                              <span style={{ marginLeft: "4px", fontSize: "10px" }}>🏢</span>
                            )}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {errorPayload.details.map((item, idx) => (
                      <tr
                        key={idx}
                        style={{
                          backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9fafb",
                        }}
                      >
                        {Object.entries(item).map(([key, val]) => {
                          const isNeedQty = key === "need_qty";
                          const isBranch = key === "branch_name" || key === "b_name" || key === "branch";
                          return (
                            <td
                              key={key}
                              style={{
                                padding: "10px 14px",
                                borderBottom:
                                  idx < errorPayload.details.length - 1
                                    ? "1px solid #f3f4f6"
                                    : "none",
                                backgroundColor: isNeedQty ? "#e6f4ef" : isBranch ? "#f0fdf4" : "transparent",
                                color: isNeedQty ? "#007c41" : isBranch ? "#007c41" : "#4b5563",
                                fontWeight: isNeedQty || isBranch ? 700 : 400,
                                fontSize: isNeedQty ? "14px" : "13px",
                              }}
                            >
                              {typeof val === "number" &&
                                (key.includes("qty") || key.includes("quantity"))
                                ? formatQty(val)
                                : String(val ?? "")}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : errorPayload?.details ? (
            <div
              className="p-3 rounded"
              style={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb" }}
            >
              <pre className="mb-0" style={{ fontSize: "13px", color: "#4b5563" }}>
                {JSON.stringify(errorPayload.details, null, 2)}
              </pre>
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter className="border-top-0 pt-0">
          <Button
            onClick={closeErrorModal}
            variant="outline-secondary"
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#e5e7eb";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#f3f4f6";
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Dashboardmain;